import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EmptyView from "../../../../Component/EmptyView/EmptyView";
import Spinner from "../../../../Component/Spinner/Spinner";
import { dynamicReplace } from "./ActionModal";
import { ENTITY_LABELS } from "../../../../utils/labelMapping";


const ActionCard = ({
  number,
  title,
  descriptions,
  addSelectedItemsHandler,
  llm
}) => {
  const [expandedIndexes, setExpandedIndexes] = useState({});
  const [selectedIndexes, setSelectedIndexes] = useState({});
  const [visibleInfoCounts, setVisibleInfoCounts] = useState({});
const titleMapping = {
  reach: ENTITY_LABELS.rank,
  risk: "Performance",
  sentiment: "Sentiment",
};
  const handleLoadMore = (index) => {
    setVisibleInfoCounts((prev) => ({
      ...prev,
      [index]: (prev[index] || 5) + 5, // increase count for this accordion
    }));
  };

  const handleToggle = (index) => {
    setExpandedIndexes((prev) => {
      const isExpanding = !prev[index];

      if (!isExpanding) {
        // Reset visible count to 5 when accordion closes
        setVisibleInfoCounts((counts) => ({
          ...counts,
          [index]: 5,
        }));
      }

      return {
        ...prev,
        [index]: isExpanding,
      };
    });
  };


  const handleCheckboxChange = (index, desc) => {
    addSelectedItemsHandler(desc);
    setSelectedIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        mb: 2,
        p: 2,
        backgroundColor: "#EFF4F8",
        borderRadius: "8px",
        boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box
        sx={{
          width: "110px",
          height: "80px",
          borderRadius: "8px",
          backgroundColor: "#DDE0E2",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mr: 2,
        }}
      >
        <Typography
          variant="caption"
          sx={{ fontSize: "15px", color: "#3C4041", fontWeight: "bold" }}
        >
          {titleMapping?.[title]}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, color: "#3C4041", fontSize: "15px" }}
        >
          {number}
        </Typography>
      </Box>

      {/* Right Accordion Section */}
      <Box sx={{ flex: 1 }}>
        {descriptions.map((desc, index) => (
          <Accordion
            key={index}
            expanded={!!expandedIndexes[index]}
            sx={{
              mb: 1,
              borderRadius: "4px",
              boxShadow: "none",
              "&:before": { display: "none" },
              backgroundColor: expandedIndexes[index] ? "#e8f4fa" : "#ffffff",
            }}
          >
            <AccordionSummary
              expandIcon={null}
              sx={{
                alignItems: "center",
                px: 1,
                py: 0,
                height: "10px",
                "& .MuiAccordionSummary-content": {
                  alignItems: "center",
                  justifyContent: "space-between",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexShrink: 0,
                  cursor: "pointer",
                  mr: 1,
                  transform: expandedIndexes[index]
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.2s ease-in-out",
                }}
                onClick={() => handleToggle(index)}
              >
                <ExpandMoreIcon />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#333333",
                    fontWeight: 500,
                    lineHeight: "20px",
                  }}
                >
                  {dynamicReplace(desc?.text)}
                </Typography>
              </Box>

              <Checkbox
                checked={!!selectedIndexes[index]}
                onChange={() => handleCheckboxChange(index, desc)}
              />
            </AccordionSummary>

            <AccordionDetails
              sx={{
                px: 1,
                py: 1,
                backgroundColor: "#f8f8f8",
              }}
            >
              {desc?.compTitles && desc?.compTitles.length ? (
                <>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#555555",
                      lineHeight: "18px",
                    }}
                  >
                    {desc?.compTitles?.map((item, idx) => (
                      <p style={{ fontSize: "14px" }} key={idx}>
                        {dynamicReplace(item)}
                      </p>
                    ))}
                  </Typography>
                  <p></p>
                </>
              ) : null}

              {desc?.additionalInfo && desc?.additionalInfo.length &&
                llm?.toLowerCase().includes("search")
                ? (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#555555",
                      lineHeight: "18px",
                    }}
                  >
                    <h6>Data Sources:</h6>
                    {(() => {
                      const visibleCount = visibleInfoCounts[index] || 5;
                      const items = desc?.additionalInfo?.slice(0, visibleCount) || [];

                      return (
                        <>
                          {items.map((item, idx) => (
                            <p key={idx}>{item}</p>
                          ))}

                          {visibleCount < desc?.additionalInfo?.length && (
                            <button
                              style={{
                                marginTop: "-20px",
                                fontSize: "12px",
                                color: "#1976d2",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                marginLeft: '-5px'
                              }}
                              onClick={() => handleLoadMore(index)}
                            >
                              Load More Sources..
                            </button>
                          )}
                        </>
                      );
                    })()}

                  </Typography>
                ) : null}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

const RealtimeActions = ({
  realtimeActions,
  isActionsLoading,
  saveActions,
  isLoading,
  selectedInput
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const addSelectedItemsHandler = (desc) => {
    let currentSelectedItems = [...selectedItems];
    if (currentSelectedItems.some((item) => item.text === desc.text)) {
      currentSelectedItems = currentSelectedItems.filter(
        (item) => item.text !== desc.text
      );
    } else {
      currentSelectedItems.push(desc);
    }
    setSelectedItems(currentSelectedItems);
  };

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333333" }}>
          Recommended Actions
        </Typography>
        {realtimeActions?.some((item) => item?.number !== 0) &&
          !isActionsLoading &&
          isLoading ? (
          <Spinner />
        ) : (
          <Button
            disabled={!selectedItems || selectedItems.length === 0}
            onClick={() => {
              saveActions(selectedItems);
            }}
            sx={{
              backgroundColor: "#4FD1C5",
              color: "#ffffff",
              fontWeight: "bold",
              textTransform: "none",
              px: 3,
              py: 1,
              "&:hover": { backgroundColor: "#5eb8e0" },
              borderRadius: "8px",
            }}
          >
            Add all to action list +
          </Button>
        )}
      </Box>

      {isActionsLoading ? (
        <Spinner />
      ) : realtimeActions?.some((item) => item?.number !== 0) ? (
        <Grid container spacing={1}>
          {realtimeActions.map((action, index) => (
            <Grid item xs={12} key={index}>
              {action.number ? (
                <ActionCard
                  number={action.number}
                  title={action?.title || action?.mainTitle}
                  descriptions={action.descriptions}
                  addSelectedItemsHandler={addSelectedItemsHandler}
                  llm={selectedInput?.llm}
                />
              ) : null}
            </Grid>
          ))}
        </Grid>
      ) : (
        <EmptyView message="Nothing here!" />
      )}
    </Box>
  );
};

export default RealtimeActions;
